import { CustomerReportsTypes as Type } from '../../../types/customerreport';

const initialState = {
  reOpenTicket: null,
  loading: false,
  error: null,
};

const ReOpenCustomerReporTicketReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.REOPEN_CUSTOMER_REPORT_TICKET_REQUEST:
      return { ...state, loading: true, error: null, reOpenTicket: null };
    case Type.REOPEN_CUSTOMER_REPORT_TICKET_REQUEST_SUCCESS:
      return {
        ...state,
        reOpenTicket: action.payload,
        loading: false,
      };
    case Type.REOPEN_CUSTOMER_REPORT_TICKET_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false };
    case Type.RESET_REOPEN_TICKET_STATE:
        return { ...initialState };
    default:
      return state;
  }
};

export default ReOpenCustomerReporTicketReducer;